// ============================================================
// CALENDLY : ouverture en pop-up + suivi de la reservation
// ============================================================
// Les boutons "Reserver une demo" ouvraient calendly.com dans un
// nouvel onglet, ce qui rendait la reservation intracable : Calendly
// ne peut rien renvoyer a Google Tag Manager depuis son propre site.
// On passe donc par le widget officiel, qui affiche Calendly dans une
// iframe au-dessus du site et emet un message postMessage a chaque
// etape. On ecoute la confirmation de reservation et on la pousse
// dans le dataLayer sous le nom 'demo_booked'.
// Cote GTM : creer un declencheur Custom Event 'demo_booked' et y
// brancher les tags GA4 / Google Ads / Meta, comme pour 'sign_up_trial'.

import { detectCountry } from "@/services/countries";
import { openDemoForm } from "@/utils/hubspotDemoForm";

export const CALENDLY_DEMO_URL =
  "https://calendly.com/d/cytz-wbs-3xn/demo-query-juriste-ia-recherche-juridique";

const CALENDLY_ORIGIN = "https://calendly.com";
const WIDGET_JS = "https://assets.calendly.com/assets/external/widget.js";
const WIDGET_CSS = "https://assets.calendly.com/assets/external/widget.css";

// Le widget n'est charge qu'au premier clic, pour ne pas alourdir
// le chargement initial des pages publiques.
let widgetPromise = null;

function loadWidget() {
  if (widgetPromise) return widgetPromise;

  widgetPromise = new Promise((resolve, reject) => {
    if (window.Calendly) {
      resolve();
      return;
    }

    if (!document.querySelector('link[href="' + WIDGET_CSS + '"]')) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = WIDGET_CSS;
      document.head.appendChild(link);
    }

    const script = document.createElement("script");
    script.src = WIDGET_JS;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () =>
      reject(new Error("Calendly widget script failed to load"));
    document.head.appendChild(script);
  });

  return widgetPromise;
}

// Repli si le widget ne se charge pas (bloqueur de pub, reseau) :
// on retombe sur l'ancien comportement, un onglet vers Calendly.
function openInNewTab() {
  window.open(CALENDLY_DEMO_URL, "_blank", "noopener");
}

export function openCalendlyDemo(event) {
  if (event && typeof event.preventDefault === "function")
    event.preventDefault();

  // France : les demandes de demo passent par le formulaire HubSpot
  // (voir hubspotDemoForm.js). Calendly reste en place pour l'Italie.
  if (detectCountry() !== "IT") {
    openDemoForm();
    return;
  }

  loadWidget()
    .then(() => {
      if (
        window.Calendly &&
        typeof window.Calendly.initPopupWidget === "function"
      ) {
        window.Calendly.initPopupWidget({ url: CALENDLY_DEMO_URL });
      } else {
        openInNewTab();
      }
    })
    .catch(openInNewTab);
}

function isCalendlyEvent(e) {
  return (
    e.origin === CALENDLY_ORIGIN &&
    e.data &&
    typeof e.data.event === "string" &&
    e.data.event.indexOf("calendly.") === 0
  );
}

let trackingReady = false;

export function initCalendlyTracking() {
  if (trackingReady) return;
  trackingReady = true;

  window.addEventListener("message", (e) => {
    if (!isCalendlyEvent(e)) return;
    if (e.data.event !== "calendly.event_scheduled") return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "demo_booked" });
  });
}
